import Vue from "vue";
import App from "./App.vue";
import UpdateRequired from "./UpdateRequired.vue";
import BetaComplete from "./BetaComplete.vue";
import Menu from "./Menu.vue";
import store from "@/store";

import remoteConfig from "@/services/config.js";
import compareVersions from "compare-versions";
import { differenceInDays } from "date-fns";

import { dateFilter } from "vue-date-fns";
Vue.filter("date", dateFilter);

import http from "@/services/http";
Vue.use(http);

import Loading from "@/util/loading/directive";
Vue.use(Loading);

import filterObject from "@/util/filter-object";
Vue.mixin({
  filters: {
    decode(val) {
      let txt = document.createElement("textarea");
      txt.innerHTML = val;
      return txt.value;
    },
  },
  methods: {
    filterObject,
  },
});

import genUniqueKey from "@/util/gen-unique-key";
Vue.mixin({
  methods: { genUniqueKey },
});

async function docketStart() {
  // get remote config and set beta days
  try {
    await remoteConfig.fetchAndActivate();
  } catch (e) {
    console.error(e);
  }
  store.set(
    "ui/betaDays",
    differenceInDays(
      new Date(remoteConfig.getValue("beta_complete_date").asString()),
      new Date()
    )
  );

  const menu = new Vue(Menu);
  menu.$mount("#wp-admin-bar-wp-go-live");

  if (window?.wp?.plugins) {
    (function(wp) {
      var registerPlugin = wp.plugins.registerPlugin;
      var Fragment = wp.element.Fragment;
      var PluginSidebar = wp.editPost.PluginSidebar;
      var PluginSidebarMoreMenuItem = wp.editPost.PluginSidebarMoreMenuItem;
      var el = wp.element.createElement;
      var domReady = wp.domReady;

      registerPlugin("docket-wp", {
        render: function() {
          return el(
            Fragment,
            {},
            el(
              PluginSidebar,
              {
                className: "dwp-plugin-open",
                name: "docket-wp",
                icon: "list-view",
                title: "Docket WP",
              },
              el(
                "div",
                {
                  className: "plugin-sidebar-content",
                  style: { padding: "20px" },
                },
                el(
                  "span",
                  { className: "" },
                  "DocketWP lets you quickly carry out complex, routine tasks with more efficiency using integrated checklists."
                )
              )
            )
          );
        },
      });

      domReady(() => {
        const menu = new Vue(Menu);
        menu.$mount("[aria-label='Docket WP']");
      });
    })(window.wp);
  }

  if (remoteConfig.getValue("required_version").asString()) {
    if (
      compareVersions.compare(
        remoteConfig.getValue("required_version").asString(),
        docketData.version,
        ">"
      )
    ) {
      const app = new Vue(UpdateRequired);
      app.$mount("#wp-admin-bar-app");
      return;
    }
    if (store.get("ui/betaDays") < 1) {
      const app = new Vue(BetaComplete);
      app.$mount("#wp-admin-bar-app");
      return;
    }
  }

  const app = new Vue(App);
  app.$mount("#wp-admin-bar-app");
}

docketStart();
